import moment from "moment"
import JSZip from "jszip"

export const isEmailAddressValid = (emailAddress) => {
    return String(emailAddress)
        .toLowerCase()
        .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
}

export const formatDate = (date) => {
    let validDateValue
    let validFormat = "YYYY-MM-DD"
    if(moment(date, validFormat).format(validFormat) === date) {
        validDateValue = date
    } else {
        validDateValue = moment(date, "DD/MM/YYYY").format(validFormat)
    }
    return validDateValue
}

export const formatDollarAmount = (value) => {
    if(value && value.trim()) {
        let formattedValue = value.replaceAll("$", "").replaceAll(",", "")

        if(!isNaN(formattedValue)) {
            formattedValue = parseFloat(formattedValue).toLocaleString('en', {minimumFractionDigits: 0, maximumFractionDigits: 9})
            value =  "$" + (formattedValue.includes(".") ? formattedValue : (formattedValue + (".00")))
        }
    }
    return value
}

export const isNumber = (value) => {
    let formattedValue = value.replaceAll(",", "").replaceAll("$", "")
    return formattedValue && !isNaN(formattedValue)
}

export const formatNumber = (value) => {
    let isMoney = value.includes("$")
    let isDecimal = value.endsWith(".")
    let formattedValue = value.replaceAll(",", "").replaceAll("$", "")

    return (isMoney ? "$" : "") + parseFloat(formattedValue).toLocaleString('en', {minimumFractionDigits: 0, maximumFractionDigits: 9}) + (isDecimal ? "." : "")
}

export const downloadFile = (file, filename) => {
    const url = window.URL.createObjectURL(file)

    const hiddenElement = document.createElement("a")
    hiddenElement.href = url
    hiddenElement.download = filename

    document.body.appendChild(hiddenElement)
    hiddenElement.click()
    hiddenElement.remove()

    window.URL.revokeObjectURL(url);
}

export const createZipFile = async (documents) => {
    const zip = new JSZip()

    documents.forEach((document) => {
        if (typeof document.content === "string") {
            // Java byte[] serialized by Spring Boot as Base64
            zip.file(document.fileName, document.content, {
                base64: true
            })
        } else {
            // Numeric byte array
            zip.file(
                document.fileName,
                new Uint8Array(document.content)
            )
        }
    })

    return await zip.generateAsync({
        type: "blob",
        mimeType: "application/zip"
    })
};